function setDefaultZoomImage() {
    const url = $('.default-zoom-image').data('zoom-image').split('?')[0];
    $('.zoom-image').css({'background-image': 'url(\'' + url + '\')'});
}
function setZoomImage(url) {
    $('.zoom-image').css({'background-image': 'url(\'' + url + '\')'});
}
function zoom(e) {
    setDefaultZoomImage();
    var zoomer = e.currentTarget;
    let offsetX = e.offsetX || e.touches && e.touches[0].pageX;
    let offsetY;
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches && e.touches[0].pageX;
    let x = offsetX/zoomer.offsetWidth*100;
    let y = offsetY/zoomer.offsetHeight*100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

function mobileZoom() {
    new window.SimpleLightbox('#mobile-gallery a', {
        overlayOpacity: 1.0,
        closeText: '✕',
        swipeClose: false,
        docClose: false,
        fadeSpeed: 100
    });

    $('.jqzoom').jqzoom({
        zoomType: 'standard',
        lens:true,
        preloadImages: false,
        alwaysOn:false,
        xOffset: 0,
        yOffset: 0,
        zoomWidth: $('.pdp-col-right').innerWidth() - 30,
        zoomHeight: $('.image-block').outerHeight()
    });

    var desktopGallery = new window.SimpleLightbox('.gallery a', {
        overlayOpacity: 1.0,
        closeText: '✕',
        swipeClose: false,
        docClose: false,
        fadeSpeed: 100
    });

    $('.jqzoom').on('click', e => {
        e.preventDefault();
        const href = e.currentTarget.href;
        const galleryImage = $('.gallery a[href="' + href + '"]');
        desktopGallery.open(galleryImage);
    });

    $('.image-block__thumbnail *').on('mouseenter', e => {
        $('.image-block__image').toggleClass('full-bleed', $(e.currentTarget).closest('.image-block__thumbnail').hasClass('full-bleed'));
    });
}

module.exports = {
    setDefaultZoomImage: setDefaultZoomImage,
    setZoomImage: setZoomImage,
    zoom: zoom,
    mobileZoom: mobileZoom
};
